<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FjxSMI/tc-custom/9781609254025.jpg?1736946045843" alt="This image is the cover for the book Saturn in Transit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saturn in Transit
      </h1>
      <p class="bookDescription body article font2">
        <b>“</b><b>A</b><b>n elegant guide to working with Saturn energy in your life</b><b>” by the author of </b><b><i>The Astrology of Midlife and Aging </i></b><b>(FindAnAstrologer.com).</b><br/>  <br/><i>Saturn in Transit</i> reveals Saturn’s useful and developmental influence in our lives. Erin Sullivan gives a thorough account of the astrology, mythology, and psychology of Saturn’s role as the source of divine discontent. Saturn assists the modern hero and heroine, during its transit around the zodiac, by destroying the old and outmoded within, and throwing us periodically into chaos, which invariably generates a creative transformation of purpose in our lives.<br/>  <br/><b>“One of the very best books on Saturn, great insights . . . </b>Sullivan draws extensively on depth psychology and classical mythology to portray Saturn’s developmental influence on our lives.”—<i>The Tim Burness Blog</i><br/>  <br/> “I highly recommend this book. In fact, it has informed many aspects of my own practice and is a go-to book when preparing clients charts . . . Without a doubt, this is a must-have book in your astrological library.”—<i>Ask Astrology</i><br/>  <br/> “A very good book on Saturn cycles.”—soulhealing.com
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erin Sullivan
      </h2>
      
      <p class="authorDescription body article">Samara Anjelae is an award-winning author, gifted mystic and spiritual strategist. Samara's mystical and medium abilities awakened and heightened in 1991 after she encountered her guardian angel that changed the course of her life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Samuel Weiser, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5131f02a